// The index.ts file is a barrel file that re-exports components from the _services folder so they can be imported in other files using only the folder path
// (e.g. './_service') instead of the full path to the component (e.g. './_services/authentication.service.ts').
// For more info on TypeScript barrel files see https://basarat.gitbooks.io/typescript/docs/tips/barrel.html.
export * from './authentication.service';
